export default __webpack_public_path__ + "static/media/pngLogo.2cdd8f0e.svg";